<template>
  <div style="height:100%">

    <!-- 景点内容区开始 -->
     <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom:10px">
            <el-breadcrumb-item :to="{ name: 'storeManagement',params:{routerLink:routerInfo} }">景区</el-breadcrumb-item>
            <el-breadcrumb-item>景点</el-breadcrumb-item>
        </el-breadcrumb>
    <el-card class="scroll"   style="height:100%;margin:0 0 10px 0;overflow-y:scroll;  box-sizing: content-box;" id="ceshi">
      <el-button @click="dialogVisibleAddScenic=true,dolxInfo=1" type="success" size="small">新增景点</el-button>
      <hr/>
      <el-row :gutter="30" >
        <el-col :xs="8" :sm="6" :md="12" :lg="8" :xl="6" :key="'spot' + feng.spot_id" style="margin-bottom:30px" v-for="feng in scenicList">
          <div style=" border: 1px solid #eee;   border-color: #bbb;box-shadow: 2px 2px 2px #ddd;padding:1px 1px 10px 1px">
            <img  @contextmenu.prevent="dialogVisible=true,dialogImageUrl= feng.spot_pic" :src="feng.spot_pic" style="width:100%;min-height:210px;max-height:210px;">
            <ul>
              <li class="scenicName">{{feng.spot_name}}</li>
              <li style="color:#FF6913;font-size:26px;margin:15px 10px 0 10px;text-align:right"> <span > <el-button type="warning" @click="updateScenic(feng)" size="mini" >修改</el-button> <el-button type="info" @click="scenicDelete(feng)" size="mini">删除</el-button></span></li>
            </ul>
          </div>
        </el-col>
      </el-row>
       <!-- 分页区 -->
                <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="pageSize"
                            layout="total,  prev, pager, next, jumper"
                        :total="total" style="text-align:right;margin:0 16px 30px 0;border-radius:20px">
                </el-pagination>
    </el-card>
    <!-- 景点内容区结束 -->
    <!-- 新增修改景区弹出框开始 -->
      <el-dialog
          title="景点设置"
          :visible.sync="dialogVisibleAddScenic"
          :close-on-press-escape="false"
          :close-on-click-modal="false"
          @close="dialogVisibleAddScenicClose()"
          width="700px"
          >
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
              <el-form-item label="景区名称" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
              </el-form-item>

              <el-form-item label="在列表中加粗" prop="is_bold">
                <el-checkbox v-model="ruleForm.is_bold" true-label='1' false-label='0'></el-checkbox>
              </el-form-item>

              <el-form-item label="景区图片" >
                <el-upload style="width: 100%;"
                   class="avatar-uploader"

                   action="string"
                   :http-request='submitUploadScenicPhoto'
                   :show-file-list="false"
                 >
                  <img  @contextmenu.prevent="dialogVisible=true,dialogImageUrl= scenicPhoto" v-if="scenicPhoto" :src="scenicPhoto" class="avatar" style="width:120px;height:120px;border:1px solid #e8e8e8">
                  <i v-else class="el-icon-plus avatar-uploader-icon" style="line-height:110px;width:120px;height:120px;border:1px solid #e8e8e8;vertical-align: middle;"></i>
                </el-upload>
              </el-form-item>
               <el-form-item label="语音简介">
                  <el-upload
                    action="string"
                      class="upload-demo"
                     :http-request='submit'
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :before-remove="beforeRemove"
                      multiple
                      :limit="1"
                          v-loading="loading"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      :file-list="fileList">
                      <el-button size="small" type="primary">点击上传</el-button>

                    </el-upload>
              </el-form-item>

              <el-form-item label="景区左下（经、纬）" >
                <el-col :span="11">
                    <el-form-item prop="leftLongitude">
                       <el-input v-model="ruleForm.leftLongitude" placeholder="请输入经度" oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,10)"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="2" style="text-align:center">-</el-col>
                  <el-col :span="11">
                    <el-form-item prop="leftLatitude">
                       <el-input v-model="ruleForm.leftLatitude" placeholder="请输入纬度" oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,10)"></el-input>
                    </el-form-item>
                  </el-col>
              </el-form-item>
              <el-form-item label="景区右上（经、纬）" >
                  <el-col :span="11">
                    <el-form-item prop="rightLongitude">
                       <el-input v-model="ruleForm.rightLongitude" placeholder="请输入经度" oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,10)"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col class="line" :span="2" style="text-align:center">-</el-col>
                  <el-col :span="11">
                    <el-form-item prop="rightLatitude">
                       <el-input v-model="ruleForm.rightLatitude" placeholder="请输入纬度" oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,10)"></el-input>
                    </el-form-item>
                  </el-col>
              </el-form-item>
              <el-form-item label="景区经度" prop="longitude">
                <el-input v-model="ruleForm.longitude" oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,10)"></el-input>
              </el-form-item>
                <el-form-item label="景区纬度" prop="latitude">
                <el-input v-model="ruleForm.latitude" oninput="this.value=(this.value.replace(/[^0-9.]+/,'')).slice(0,10)"></el-input>
              </el-form-item>
              <el-form-item label="序号" prop="sort_order">
                <el-input v-model.number="ruleForm.sort_order"></el-input>
              </el-form-item>

               <el-form-item>
                <el-button type="primary" @click="submitAddScenic('ruleForm')">保存</el-button>
                <el-button @click="dialogVisibleAddScenic=false">关闭</el-button>
              </el-form-item>
          </el-form>

        </el-dialog>
    <!-- 新增景区弹出框结束 -->
    <!-- 弹出框内图片查看大图开始 -->
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    <!-- 弹出框内图片查看大图结束 -->
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import ElRow from "element-ui/packages/row/src/row";
import ElCol from "element-ui/packages/col/src/col";
import { mapState } from "vuex";
export default {
  data() {
    return {
        loading:'',
      currentPage: 1,
      pageSize: 12,
      total: 0,
      fileList:[],//音频存储
      scenicList:[],//景点信息存储数组
      dolxInfo:'',//提交状态
      dialogVisibleAddScenic: false, //新增景点弹出框状态
      dialogVisible: false, //放大图片弹出框状态
      dialogImageUrl: "", //放大图片绑定值
      scenicPhoto: "", //弹出框景点图片绑定值
      scenicMap: "", //弹出框景点地图绑定值
      ruleForm: {
        name: "",
        is_bold: 0,
        rightLongitude: "", //右上经度
        rightLatitude: "", //右上纬度
        leftLongitude: "", //左下经度
        leftLatitude: "", //左下纬度
        longitude: "", //景区经度
        latitude: "", //景区纬度
        sort_order: 0,
      },
      rules: {
        name: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
          longitude:[{ required: true, message: "请输入景点经度", trigger: "blur" }],
        latitude:[{ required: true, message: "请输入景点纬度", trigger: "blur" }],
        sort_order:[{ type: 'number', message: "序号必须为数字", trigger: "blur" }],
      },
      routerInfo:'',
    };
  },
  mounted(){
    this.routerInfo=this.$route.query.Router
    this.findScenic();//查询景点
  },
  methods: {
    //上传音频
      handleRemove(file, fileList) {

        this.fileList=fileList
      },
      handlePreview(file) {

      },
      beforeRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
      //提交音频
      submit(file){
         this.loading=true
         let param = new FormData(); // 创建 form 对象
          param.append("file", file.file, file.file.name); // 通过 append 向 form 对象添加数据
          let config = {
            headers: { "Content-Type": "multipart/form-data" }
          }; // 添加请求头
          this.$axios
        .postImageRequest("admin/putObjectYy", param, config)
        .then(response => {

          this.fileList=[]
          this.fileList.push({uid:response.data,name:'景点语音'});
          this.loading=false
        });
      },
    //景点删除
    scenicDelete(feng) {
      var that = this;


        this.$confirm("此操作将永久删除该景点,是否继续", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true
        })
          .then(() => {
            var userData = qs.parse(sessionStorage.getItem("userData"));
            var deleteData = {
              spot_id :feng.spot_id ,
              area_id : that.$route.query.ID,//景区ID
            };
            var deleteParams = {
              methodUrl: "admin/delScenicSpot",
              jsonParam: qs.stringify(deleteData)
            };
            this.$axios.postRequest(deleteParams).then(
              function(res) {
                //成功之后处理逻辑
                that.findScenic(1);
                that.$message({
                  type: "success",
                  message: "删除成功"
                });
              },
              function(res) {
                //失败之后处理逻辑
                console.log("error:" + res);
                that.$message({
                  type: "error",
                  message: "删除失败"
                });
              }
            );
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });

    },
    //修改景点触发
    updateScenic(feng) {
     var that = this;
        that.ruleForm.name = feng.spot_name//景点名称
        that.ruleForm.is_bold = feng.is_bold
        that.ruleForm.longitude = feng.spot_lng //景点经度
        that.ruleForm.latitude = feng.spot_lat //景点纬度
        that.ruleForm.sort_order = feng.sort_order || 0
        that.scenicPhoto = feng.spot_pic; //景点图片
        that.areaID=feng.spot_id ;
        that.dolxInfo = "2"; //提交状态
        that.dialogVisibleAddScenic = true;
        that.fileList = [];

        if(feng.spot_voice!=''){

           that.fileList.push({ uid: feng.spot_voice, name: "景区音频" });
        }
         var left = feng.spot_all_lng.split(",");
        if(left.length>1){
             that.ruleForm.leftLongitude = left[0];
            that.ruleForm.leftLatitude = left[1];
        }
        var right=feng.spot_all_lat.split(",")
        if(right.length>1){
          that.ruleForm.rightLongitude=right[0];
          that.ruleForm.rightLatitude=right[1];
         }
    },

    //新增景点提交
    submitAddScenic(ruleForm) {
      var userData = qs.parse(sessionStorage.getItem("userData"));
      var that = this;
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
            if(that.fileList.length==0||that.scenicPhoto==''){
               if(that.fileList.length==0){
               that.$notify({
                  message:'请选择音频',
                  type:'warning',
                   position: 'top-left'
                })
            }
            setTimeout(function(){
               if(that.scenicPhoto==''){
               that.$notify({
                  message:'请选择景点图片',
                  type:'warning',
                   position: 'top-left'
                })
            }
             }, 200);
            }else{
          var left = [];
          var right = [];
          var content=''
          if(that.fileList.length!=0){
            content=that.fileList[0].uid
          }
          if(that.ruleForm.leftLongitude!=''&&that.ruleForm.leftLatitude!=''){
            left.push(that.ruleForm.leftLongitude, that.ruleForm.leftLatitude);
            left=left.join(',')
          }else{
            left=left.join('')
          }
          if(that.ruleForm.rightLongitude!=''&&that.ruleForm.rightLatitude!=''){
            right.push(that.ruleForm.rightLongitude, that.ruleForm.rightLatitude);
            right=right.join(',')
          }else{
            right=right.join('')
          }

          var salesInfoData = {
            area_id :that.$route.query.ID,
            spot_id  :that.areaID,
            spot_name : that.ruleForm.name, // 景点名称
            is_bold: that.ruleForm.is_bold,
            spot_pic : that.scenicPhoto, //景点图片
            spot_lng : that.ruleForm.longitude, //景区坐标 经度
            spot_lat : that.ruleForm.latitude, //景区坐标 纬度
            spot_voice : content, //声音介绍
            spot_all_lng : left, //,景区左下 经度,纬度
            spot_all_lat : right, //景区右上 经度,纬度
            sort_order: that.ruleForm.sort_order,
          };
          if(that.dolxInfo=='1'){
             var salesInfoParams = {
                methodUrl: "admin/addScenicSpot",
                jsonParam: qs.stringify(salesInfoData)
              };
          }else if(that.dolxInfo=="2"){
             var salesInfoParams = {
                methodUrl: "admin/upScenicSpot",
                jsonParam: qs.stringify(salesInfoData)
              };
          }
          this.$axios.postRequest(salesInfoParams).then(
            function(res) {
              //成功之后处理逻
                that.$message({
                  message:'提交成功',
                  type:'success'
                })

              that.dialogVisibleAddScenic=false
              that.findScenic();

            },
            function(res) {
              //失败之后处理逻辑
               that.$message({
                  message:'提交失败',
                  type:'error'
                })
              console.log("error:");
            }
          );
            }
        } else {
        }
      });
    },
    //新增景区弹出框关闭
    dialogVisibleAddScenicClose() {
       var that = this;
        that.ruleForm.name = ''//景区名称
        that.ruleForm.is_bold = 0
        that.ruleForm.longitude = '' //景区经度
        that.ruleForm.latitude = '' //景区纬度
        that.ruleForm.sort_order = 0

        that.scenicPhoto ='' //景区图片

        that.fileList = [];
        that.ruleForm.leftLongitude =''
        that.ruleForm.leftLatitude =''

        that.ruleForm.rightLongitude=''
        that.ruleForm.rightLatitude=''
        that.dolxInfo = ""//提交状态
    },
    //上传景点图片
    submitUploadScenicPhoto(file) {
      let param = new FormData(); // 创建 form 对象
      param.append("file", file.file, file.file.name); // 通过 append 向 form 对象添加数据
      let config = {
        headers: { "Content-Type": "multipart/form-data" }
      }; // 添加请求头
      this.$axios
        .postImageRequest("admin/putObject", param, config)
        .then(response => {
          this.scenicPhoto = response.data;
        });
    },

    //查询景点
    findScenic(type){

      var userData = qs.parse(sessionStorage.getItem("userData"));
      var that = this;

      var salesInfoData = {
       area_id :that.$route.query.ID, //景区ID ,

        count: true,
        // orderby: "spot_id desc",
        pageindex: this.currentPage,
        pagesize: this.pageSize
      };

      var salesInfoParams = {
        methodUrl: "admin/getScenicSpot",
        jsonParam: qs.stringify(salesInfoData)
      };
      this.$axios.postRequest(salesInfoParams).then(
        function(res) {
          //成功之后处理逻辑
          that.scenicList = res.data.list;

          that.total = res.data.totalcount;
           document.getElementById('ceshi').scrollTop = 0;
        },
        function(res) {
          //失败之后处理逻辑
          console.log("error:");
        }
      );
    },
     //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.findScenic();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.findScenic();
    }
  }
};
</script>

<style scoped>
.scroll::-webkit-scrollbar {
    display: none;
}
/*景区名称*/
.scenicName {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  line-height: 25px;
  color: #333;
  font-size: 16px;
  height:50px;
  margin: 10px 10px 0 10px;
}
</style>




// WEBPACK FOOTER //
// src/components/storeManagementList/shopDetails.vue